import defaultAttributes from '../defaultAttributes';

const ChevronsUpDown = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M7 15l5 5 5-5' }], ['path', { d: 'M7 9l5-5 5 5' }]],
];

export default ChevronsUpDown;
